import React from 'react';
import ChartContainer from './ChartContainer';
import { useServicesChartsDataContext } from '../../hooks/useServicesChartsDataContext';
import useServicesPerYearPercentageChart from './hooks/useServicesPerYearPercentageChart';

export const ServicesPerYearPercentage = ({ heigth = 400 }) => {
    const { module } = useServicesChartsDataContext();
    const { chartConfig } = useServicesPerYearPercentageChart();

    return (
        <ChartContainer
            title={`Evolução ${module.sectionTitle} por Ano (%)`}
            options={chartConfig.options}
            series={chartConfig.series}
            height={350}
        />
    );
};
